var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-select',{attrs:{"value":_vm.value,"placeholder":_vm.label},on:{"input":_vm.onChange}},[_c('option',{attrs:{"label":_vm.$tc('yearly'),"value":"Yearly"}}),_c('option',{attrs:{"label":_vm.$tc('monthly'),"value":"Monthly"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }